<template>
  <!-- TODO: We'll end up removing these most likely - temp fix for clients -->
  <div id="zoom-buttons" class="zoom-buttons">
    <slot name="buttons" v-bind="{ zoomIn, zoomOut }">
      <v-btn tile density="compact" icon variant="text" size="small" @click="zoomIn">
        <v-icon size="small">mdi-magnify-plus</v-icon>
      </v-btn>
      <v-btn tile icon density="compact" size="small" variant="text" @click="zoomOut">
        <v-icon size="small">mdi-magnify-minus</v-icon>
      </v-btn>
    </slot>
    <div class="text--color-neutral-60 ml-4 flex-1 font-size-x-small zoom-label">
      {{ $t('grid.labels.zoomLevel') }}: {{ currentZoom }}
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: {
    storeInLocalStorage: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      currentZoom: 100
    };
  },
  methods: {
    zoomIn() {
      if (this.currentZoom < 130) {
        this.currentZoom += 5;
      } else {
        this.currentZoom = 130;
      }
    },
    zoomOut() {
      if (this.currentZoom > 90) {
        this.currentZoom -= 5;
      } else {
        this.currentZoom = 90;
      }
    }
  },
  mounted() {
    this.currentZoom = this.$zoomLevel < 90 ? 90 : this.$zoomLevel > 130 ? 130 : this.$zoomLevel;
  },
  watch: {
    currentZoom: debounce(function (newVal) {
      this.$store.dispatch('Calendar/setZoomLevel', {
        zoom: this.novaCore.roundToNearestNumber(newVal, 5, false),
        storeInLocalStorage: this.storeInLocalStorage
      });
    }, 300)
  }
};
</script>

<style lang="scss" scoped>
.zoom-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 200px;
  flex-wrap: nowrap;

  button {
    width: 43px !important;
    border: 1px solid $color-neutral-30;
    &:first-child {
      border-right: 0;
    }
  }
}
</style>
